import React from 'react';
import styled from 'styled-components';

const Button = styled.button<ButtonProps>`
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, priority, bgColor }) =>
    bgColor ? bgColor : priority === 'primary' ? theme.colors.primary : '#d5d5d5'};
  color: #000;
  border: 0;
  border-radius: 3px;
  font-family: 'Clas Ohlson Sans Web', 'Open Sans', 'Arial' !important;
  font-size: 12px;
  font-weight: bold;
  text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : 'none')};
  cursor: pointer;
  padding: 0 20px;
  transition: background-color 0.2s ease;
  &:disabled {
    opacity: 0.7;
    cursor: default;
  }
  &:hover {
    background-color: ${({ priority }) => (priority === 'primary' ? '#54BDE3' : '#A8ACAD')};
  }
`;

interface ButtonProps {
  priority?: 'primary' | 'secondary';
  uppercase?: boolean;
  bgColor?: string;
}

export const CustomButton = ({ priority = 'primary', uppercase = false, ...rest }: any) => {
  return <Button {...rest} uppercase={uppercase} priority={priority} />;
};
